import gql from 'graphql-tag';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';

// We provide a fallback while it's loading
const fallback: AvailableAnalysisDataGq = {
  keywordData: false,
  taggedData: false,
  serpData: false,
  monthlyData: false,
};

export function useGetAvailableAnalysisDataGq(command: CommandGq) {
  const query = useCustomQuery<DataGq, Variables>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getAvailableAnalysisData ?? fallback,
  };
}

const gqTag = gql`
  query GetAvailableAnalysisData($command: GetAvailableAnalysisDataCommand!) {
    projects {
      getAvailableAnalysisData(command: $command) {
        keywordData
        taggedData
        serpData
        monthlyData
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getAvailableAnalysisData: AvailableAnalysisDataGq;
  };
}

export interface AvailableAnalysisDataGq {
  readonly keywordData: boolean;
  readonly taggedData: boolean;
  readonly serpData: boolean;
  readonly monthlyData: boolean;
}

export interface Variables {
  readonly command: CommandGq;
}
export interface CommandGq {
  readonly serpOnly: boolean;
  readonly projectId: number;
}
